// ChatNotificationModal.js

import React, { useMemo } from "react";

import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Paper,
  Box,
  Badge,
  Divider,
} from "@mui/material";


const ChatNotificationModal = ({
  notificationschat,
  onClose,
  markAsRead,
}) => {


  // Keep latest message per sender
  const latestBySender = useMemo(() => {

    const sorted = [...notificationschat].sort(
      (a, b) =>
        new Date(b.created_at) -
        new Date(a.created_at)
    );


    const unique = new Map();


    sorted.forEach((notif) => {

      if (!unique.has(notif.sender)) {
        unique.set(
          notif.sender,
          notif
        );
      }

    });


    return Array.from(
      unique.values()
    );

  }, [notificationschat]);



  const handleClick = (id) => {

    markAsRead(id);

    onClose();

  };



  return (

    <Paper

      elevation={12}

      sx={{

        position: "fixed",

        top: 65,

        right: {
          xs: 8,
          sm: 20,
        },


        width: {
          xs: "calc(100vw - 20px)",
          sm: 370,
        },


        maxWidth: "95vw",

        zIndex: 1500,


        borderRadius: 4,


        overflow: "hidden",


        background:
          "linear-gradient(145deg,#ffffff,#f3f3f3)",


        border:
          "1px solid rgba(255,255,255,.6)",


        boxShadow:
          "0 20px 50px rgba(0,0,0,.25)",

      }}

    >


      {/* HEADER */}

      <Box

        sx={{

          background:
            "linear-gradient(135deg,#1a1a1a,#3b3b3b)",


          px: 2.5,

          py: 1.8,


          display:"flex",

          alignItems:"center",

          justifyContent:"space-between",

        }}

      >

        <Typography

          sx={{

            color:"#fff",

            fontWeight:800,

            fontSize:18,

            letterSpacing:.5,

          }}

        >

          Chat Messages

        </Typography>


        <Badge

          badgeContent={
            latestBySender.filter(
              n => !n.is_read
            ).length
          }

          sx={{

            "& .MuiBadge-badge":{

              backgroundColor:"#ff6d00",

              color:"#fff",

              fontWeight:700,

            }

          }}

        >

          <Box

            sx={{

              width:32,

              height:32,

              borderRadius:"50%",


              background:
              "linear-gradient(135deg,#ff6d00,#76ff03)",


              display:"flex",

              alignItems:"center",

              justifyContent:"center",

              color:"#000",

              fontWeight:900,

            }}

          >

            M

          </Box>


        </Badge>


      </Box>



      <Divider />



      {/* BODY */}

      <Box

        sx={{

          maxHeight:420,

          overflowY:"auto",


          "&::-webkit-scrollbar":{

            width:6,

          },


          "&::-webkit-scrollbar-thumb":{

            background:"#ff6d00",

            borderRadius:10,

          },

        }}

      >


        <List

          sx={{

            p:1.2,

          }}

        >


          {
            latestBySender.length > 0 ? (


              latestBySender.map(
                (notification)=>


                <ListItem


                  key={
                    notification.id
                  }


                  onClick={() =>
                    handleClick(
                      notification.id
                    )
                  }


                  sx={{

                    mb:1,


                    borderRadius:3,


                    cursor:"pointer",


                    backgroundColor:
                    notification.is_read

                    ? "#ffffff"

                    : "rgba(255,109,0,.10)",



                    border:
                    notification.is_read

                    ? "1px solid #eeeeee"

                    : "1px solid rgba(255,109,0,.35)",



                    transition:
                    "all .25s ease",



                    // ONLY THIS ITEM HOVERS

                    "&:hover":{

                      transform:
                      "translateY(-3px)",


                      background:
                      "linear-gradient(135deg,#fff3e0,#f1f8e9)",


                      boxShadow:
                      "0 8px 20px rgba(0,0,0,.12)",

                    },


                  }}

                >


                  <ListItemAvatar>


                    <Badge

                      variant="dot"

                      invisible={
                        notification.is_read
                      }


                      sx={{

                        "& .MuiBadge-badge":{

                          backgroundColor:
                          "#76ff03",

                          width:10,

                          height:10,

                          borderRadius:"50%",

                          border:
                          "2px solid white",

                        }

                      }}

                    >


                      <Avatar

                        src={
                          notification.sender_profile_image_url
                        }


                        sx={{

                          width:48,

                          height:48,


                          border:
                          "3px solid #ff6d00",

                        }}

                      />


                    </Badge>


                  </ListItemAvatar>




                  <ListItemText


                    primary={


                      <Typography

                        noWrap

                        sx={{

                          fontWeight:
                          notification.is_read
                          ? 600
                          : 900,


                          color:"#212121",

                          fontSize:15,

                        }}

                      >

                        {
                          notification.sender_name
                        }


                      </Typography>

                    }



                    secondary={


                      <Typography

                        noWrap


                        sx={{

                          color:"#666",

                          fontSize:13,


                          maxWidth:220,

                        }}

                      >

                        {
                          notification.message_preview?.length > 35

                          ? notification.message_preview.slice(0,35)+"..."

                          : notification.message_preview

                        }


                      </Typography>


                    }


                  />


                </ListItem>


              )


            ) : (


              <Box

                sx={{

                  py:5,

                  textAlign:"center",

                }}

              >

                <Typography

                  sx={{

                    color:"#777",

                    fontWeight:600,

                  }}

                >

                  No new messages

                </Typography>


              </Box>


            )

          }


        </List>


      </Box>


    </Paper>

  );

};


export default ChatNotificationModal;